import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { useProductSearch } from "features/global-search/api/useProductSearch"
import {
  GlobalSearchResultType,
  ProductOptionsGroup
} from "features/global-search/types/GlobalSearch"

interface UseProductOptionsGroupArgs {
  searchTerm: string | null
}

export function useProductOptionsGroup({
  searchTerm
}: UseProductOptionsGroupArgs): {
  productOptions: ProductOptionsGroup | null
  isLoading: boolean
} {
  const { t } = useTranslation()
  const { results: products, isLoading } = useProductSearch({ searchTerm })

  const productOptions = useMemo<ProductOptionsGroup | null>(() => {
    if (products.length === 0) return null
    return {
      type: GlobalSearchResultType.PRODUCT,
      label: t("Product.Products"),
      options: products.map(product => ({
        id: product.id,
        value: product.id,
        label: product.title,
        type: GlobalSearchResultType.PRODUCT,
        data: {
          obj: product.obj,
          variantKey: product.variantKey,
          articleNumber: product.articleNumber,
          matchInfo: product.matchInfo
        }
      }))
    }
  }, [products, t])

  return { productOptions, isLoading }
}
